import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../locale/messages'
import Loader from '../../Common/Loader';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import submit from './submit';
import validate from './validate';
import RadioFieldComponent from '../../Common/RadioFieldComponent/RadioFieldComponent';
import bt from '../../../components/commonStyle.css';
import s from './ManageNotificationsForm.css'


export class ManageNotificationsForm extends Component {
	static defaultProps = {
		loading: false
	};

	render() {
		const { formatMessage } = this.props.intl
		const { handleSubmit, loading, submitting } = this.props;
		const notificationRadioOption = [
			{ value: 'all', label: formatMessage(messages.allonly) },
			{ value: '2', label: formatMessage(messages.partner) },
			{ value: '1', label: formatMessage(messages.user) }
		]
		return (
			<div className={s.sectionWidth}>
				<form onSubmit={handleSubmit(submit)}>
					<div className={bt.space3}>
						<div className={bt.commonLabelText}>{formatMessage(messages.to)}:</div>
						<div className={s.notificationRadioList}>
							{notificationRadioOption?.map((item, index) => {
								return (
									<RadioFieldComponent
										key={index}
										name="to"
										value={item.value}
										label={item.label}
										containerClassName={s.notificationRadioFlex} />
								)
							})}
						</div>
					</div>
					<Field
						name="message"
						type="text"
						component={InputFieldComponent}
						componentClass="textarea"
						placeholder={formatMessage(messages.msgOnly)}
						label={formatMessage(messages.msgOnly)}
						inputClass={bt.formTextArea} />

					<div className='commonButtonContainer'>
						<Loader
							type={"button"}
							label={formatMessage(messages.submitButton)}
							show={loading}
							buttonType={'submit'}
							className={cx(bt.btnPrimary, 'loaderButtonFlex')}
							disabled={submitting || loading}
						/>
					</div>
				</form>
			</div>
		)
	}
}
ManageNotificationsForm = reduxForm({
	form: 'ManageNotificationsForm',
	onSubmit: submit,
	validate
})(ManageNotificationsForm)
const mapState = (state) => ({
	loading: state?.loader?.sendNotification,
	siteName: state?.siteSettings && state?.siteSettings?.data && state?.siteSettings?.data?.siteName
})
const mapDispatch = {

}
export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(ManageNotificationsForm)));
